import { Container, Group, AsideContainer } from '../styles';
import { ContactCompanyDataType } from '../types';

interface ContactDataCardInterface {
  contactData: ContactCompanyDataType,
}

export default function ContactDataCard({ contactData }: ContactDataCardInterface) {
  return (
    <Container>
      <div className="card-title">
        Dados do contato
      </div>
      <AsideContainer>
        <Group aside>
          <div className="title">
            Nome
          </div>
          <span>
            {contactData?.name || 'Não informado'}
          </span>
        </Group>
        <Group aside>
          <div className="title">
            CPF
          </div>
          <span>
            {contactData?.cpf || 'Não informado'}
          </span>
        </Group>
      </AsideContainer>
      <AsideContainer>
        <Group aside>
          <div className="title">
            Celular
          </div>
          <span>
            {contactData?.cellphone || 'Não informado'}
          </span>
        </Group>
        <Group aside>
          <div className="title">
            E-mail
          </div>
          <span>
            {contactData?.email || 'Não informado'}
          </span>
        </Group>
      </AsideContainer>
    </Container>
  );
}
